import { LEGACY_HOME_PATH, type SessionResponse } from '@headline/schemas'
import { redirect } from '@tanstack/react-router'
import { isStaff } from './viewer'

/**
 * A person whose app is legacy leaves Headline's pages for it. A full navigation: `/legacy/` is a
 * different app behind the same hostname, which the router cannot reach. Called first in a page's
 * loader, because `user` is null for the normal legacy person, who holds no membership.
 *
 * `app` is only there where the deploy has `LEGACY_APP=on`; without it this does nothing.
 */
export function leaveForLegacy(session: Pick<SessionResponse, 'app'>): void {
  if (session.app === 'legacy') {
    throw redirect({ href: LEGACY_HOME_PATH, reloadDocument: true })
  }
}

/**
 * Where legacy is, or null on a deploy without `LEGACY_APP=on`, which has no `/legacy/` beside it. The
 * no-access card links here as it stands: anyone it reaches has nothing else to open.
 */
export function legacyHref(session: Pick<SessionResponse, 'app'>): string | null {
  return session.app === undefined ? null : LEGACY_HOME_PATH
}

/**
 * Clipbook staff's way across to legacy, where they still serve clients on their own accounts: a
 * link and nothing more, stored nowhere, so it changes nothing about where they land at sign-in. Null
 * for everyone else, and on a deploy without `LEGACY_APP=on`.
 */
export function legacyButtonHref(session: Pick<SessionResponse, 'app' | 'user'>): string | null {
  return isStaff(session.user) ? legacyHref(session) : null
}
